import { ModelType } from '/@/modules/core/app/constants/ModelType';
import { FinalTaxesAsset } from '@/modules/tax/models/finaltaxescalculator/FinalTaxesAsset';
import { FinalTaxesPostMortemPlanType } from '@/modules/tax/enums/FinalTaxesPostMortemPlanType';

export class FinalTaxesBusinessInterestAsset extends FinalTaxesAsset {
  marketValue?: number;
  bookValue?: number;
  paidUpCapital?: number;
  postMortem?: string;
  qsbc?: boolean;

  constructor(model: Partial<FinalTaxesBusinessInterestAsset> = {}) {
    super(model);

    this.marketValue = model.marketValue ?? 0;
    this.bookValue = model.bookValue ?? 0;
    this.paidUpCapital = model.paidUpCapital ?? 0;
    this.postMortem = model.postMortem ?? '';
    this.qsbc = model.qsbc ?? false;
  }

  getModelName(): ModelType {
    return ModelType.FINAL_TAXES_BUSINESS_INTEREST_ASSET;
  }

  get formattedBookValue(): string {
    return this.formattedCurrencyValue(this.bookValue ?? 0);
  }

  get formattedPaidUpCapital(): string {
    return this.formattedCurrencyValue(this.paidUpCapital ?? 0);
  }

  get formattedPostMortem(): string {
    return FinalTaxesPostMortemPlanType.getByKey(this.postMortem)?.value ?? '';
  }

  get formattedQsbc(): string {
    return this.formattedBooleanValue(this.qsbc);
  }
}
